import { env } from '@/env'
import axios from 'axios'

const baseUrl = process.env.NODE_ENV === 'development' ? env.VUE_APP_OVERRIDE_PORTAL_URL || 'https://portal.test/client-api/' : 'https://portalserver.campingonline.se/client-api/'

const httpClient = axios.create({
  withCredentials: true, // Sanctum vill ha det
  baseURL: baseUrl,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'X-CampingOnline-Version': process.env.VUE_APP_VERSION
  }
})

export default {
  getChangelog (version) {
    return httpClient.get('changelog', {
      params: {
        version
      }
    })
  },
  getDomains () {
    return httpClient.get('domains')
  }
}
